<section #panelEl *ngIf="data" class="board-hero-video-panel">
	<div #contentHolder class="board-hero-video-panel__content">
		<div class="board-hero-video-panel__text">
			<h1 *ngIf="data.title" class="board-hero-video-panel__title">{{ data.title.value }}</h1>
			<div class="board-hero-video-panel__description rte" [innerHTML]="data.description.value | safe" #descriptionEl></div>
			<div class="board-hero-video-panel__link" *ngIf="data.links?.value">
				<app-bg-button *ngFor="let link of data.links.value"
											 class="board-hero-video-panel__button"
											 [buttonColor]="link.color.value"
											 [data]="link.link.value"></app-bg-button>
			</div>
		</div>
	</div>
	<div *ngIf="data.video; then videoBlock "></div>

	<div class="bow">
		<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 80">
			<path class="st0 cls-1" d="M1920,214H0V0S275,73,960,73,1920,0,1920,0Z" />
		</svg>
	</div>
</section>


<ng-template #videoBlock>
	<div 
		#mediaHolder 
		*ngIf="media" 
		class="board-hero-video-panel__media-holder board-hero-video-panel__media-holder--with-video"
		[ngClass]="{'board-hero-video-panel__media-holder--no-overlay': data?.removeBackgroundOverlay?.value}"
	>
		<ng-container *ngIf="!isMobile">
			<div *ngIf="media.desktop.type === 2; then videoDeskLocalBlock; else videoDeskNoLocalBlock"></div>
		</ng-container>
		<ng-container *ngIf="isMobile">
			<div *ngIf="media.mobile.type === 2; then videoMobLocalBlock; else videoMobNoLocalBlock"></div>
		</ng-container>
	</div>
</ng-template>

<ng-template #videoDeskNoLocalBlock>
	<app-iframe 
		class="board-hero-video-panel__video board-hero-video-panel__video--desktop" 
		[src]="media.desktop.url"
		[videoCode]="media.desktop.videoCode"
		[params]="''"
	></app-iframe>
</ng-template>

<ng-template #videoMobNoLocalBlock>
	<app-iframe 
		class="board-hero-video-panel__video board-hero-video-panel__video--mobile" 
		[src]="media.mobile.url"
		[videoCode]="media.mobile.videoCode"
		[params]="''"
	></app-iframe>
</ng-template>

<ng-template #videoDeskLocalBlock>
	<video 
		preload="true" 
		autoplay="autoplay" 
		loop="loop" 
		[muted]="'muted'" 
		name="media"
		class="board-hero-video-panel__video board-hero-video-panel__video--desktop"
	>
		<source [src]="media.desktop.url" type="video/mp4">
	</video>
</ng-template>

<ng-template #videoMobLocalBlock>
	<video 
		preload="true" 
		autoplay="autoplay" 
		loop="loop" 
		[muted]="'muted'" 
		name="media"
		class="board-hero-video-panel__video board-hero-video-panel__video--mobile"
	>
		<source [src]="media.mobile.url" type="video/mp4">
	</video>
</ng-template>
